






















































import { SliderVue } from "fs-pb-vue2/vueModels/app/SliderVue";
import { Component } from "vue-property-decorator";

@Component({})
export default class QuiqOperations extends SliderVue {
    /**
 * Список слайдов
 * @returns {Array<any>} - массив объектов.
 */
  get slides(): Array<any> {
    return this.configStore.quiqOperations;
  }

  sliderPos: number = 0;

  step(flag: boolean): void {
    const length: number = this.slides.length;
    const maxStep: number = Math.round(length / 4) + 1;
    if (flag && this.sliderPos < maxStep) {
      this.sliderPos++;
    } else if (!flag && this.sliderPos > 0) {
      this.sliderPos--;
    }
  }

  redirectToOperation(p) {
    const url = `/operation/0/${p.CatalogId}`;
    this.$router.push(url);
  }

  created() {
    window.addEventListener("resize", this.updateWidth);
  }
  mounted() {
    this.updateWidth();
  }
}
